// extracted by mini-css-extract-plugin
module.exports = {"yaWidgetFullWidth":"widget-ya-pay_yaWidgetFullWidth__ZWnbw","yaWidgetDisabled":"widget-ya-pay_yaWidgetDisabled__HkI_4"};